import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ border?: boolean }>`
  ${({ theme, border }) => css`
    // background-color: ${theme.colors.brandPrimary10};
    background-color: white;
    border: 1px solid ${theme.colors.neutralSilver10};
    border-radius: 8px;
    padding: 24px 18px;
    display: flex;
    justify-content: space-around;
    position: relative;

    ${border && css`
      border: 1px solid ${theme.colors.brandPrimary40};
    `}

    @media (max-width: 992px) {
      background-color: ${theme.colors.globalWhite100};
      border: 1px solid ${theme.colors.neutralSilver20};
      flex-direction: column;
      align-items: flex-start;
    }
  `}
`;

export const AmountSection = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;

    @media (max-width: 992px) {
      width: 100%;
      justify-content: space-between;
      padding-bottom: 20px;
      border-bottom: 1px solid ${theme.colors.neutralSilver30};
      margin-bottom: 20px;
    }

    @media (max-width: 360px) {
      width: 100%;
      flex-direction: column;
      padding-bottom: 20px;
      border-bottom: 1px solid ${theme.colors.neutralSilver30};
      margin-bottom: 20px;
    }
  `}
`;

export const RangeSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 0;

  button {
    align-self: center;
  }

  @media (max-width: 992px) {
    display: block;
    margin-bottom: 24px;

    button {
      align-self: flex-start;
    }
  }
`;

export const RangeRow = styled.div`
  padding: 12px 0 10px 0;
`;

export const ButtonSection = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 24px;

    @media (max-width: 992px) {
      gap: 8px;
      flex-direction: row-reverse;

      button {
        border: 1px solid ${theme.colors.neutralSilver10};
        margin-left: 4px;
      }

      button,
      a {
        font-size: 1.8rem;
      }
    }

    @media (max-width: 500px) {
      gap: 8px;

      button,
      a {
        > span {
          font-size: 1.6rem;
        }
      }
    }

    @media (max-width: 374px) {
      gap: 8px;
      flex-direction: column;
      width: 100%;

      button,
      a {
        width: 100%;
        text-align: center;

        > span {
          width: 100%;
        }
      }
    }
  `}
`;

export const Tag = styled.div`
  ${({ theme }) => css`
    display: inline-block;
    background-color: ${theme.colors.statusSuccess30};
    border-radius: 100px;
    padding: 4px 8px;
    font-size: 1.2rem;
    font-weight: 700;
    color: ${theme.colors.globalWhite100};
    line-height: 1.2;
    margin-bottom: 10px;
  `}
`;

type TextTypes = {
  size: 'small' | 'default';
};

const TextModifiers = {
  small: () => css`
    font-size: 1.2rem;
  `,
  default: () => css`
    font-size: 1.4rem;
  `,
};

export const Text = styled.p<TextTypes>`
  ${({ theme, size }) => css`
    position: relative;
    z-index: 1;
    color: ${theme.colors.neutralSilver50};

    > strong {
      font-weight: 500;
    }

    ${size && TextModifiers[size]()}
  `}
`;

export const MonthlyPayment = styled.p`
  ${({ theme }) => css`
    font-size: 2rem;
    font-weight: 400;
    color: ${theme.colors.neutralGray100};
    line-height: 1.2;
    margin: 0;

    > strong {
      font-size: 2.4rem;
      font-weight: 700;
    }
  `}
`;

export const MonthlySection = styled.div`
  ${({ theme }) => css`
    border-right: 1px solid ${theme.colors.neutralSilver20};
    margin-right: 32px;
    padding-right: 32px;

    @media (max-width: 992px) {
      border: none;
      padding-right: 0;
    }

    @media (max-width: 360px) {
      width: 100%;
      margin-right: 0;
    }
  `}
`;

export const LoanSection = styled.div`
  @media (max-width: 360px) {
    width: 100%;
  }
`;

export const LoanAmount = styled.p`
  ${({ theme }) => css`
    font-size: 1.8rem;
    font-weight: 500;
    color: ${theme.colors.neutralSilver90};
    line-height: 1.6;
    margin: 0;
  `}
`;

export const ChanceText = styled.div`
  p {
    display: inline-flex;
    align-items: center;
  }

  strong {
    margin-right: 4px;
  }

  @media (max-width: 375px) {
    p {
      font-size: 1.2rem;
    }
  }

  @media (max-width: 320px) {
    p {
      display: block;
    }
  }
`;

export const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 48px;
  position: absolute;
  right: -40px;
  z-index: 2;

  @media (max-width: 992px) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    width: 48px;
  }
`;
